module.exports = __webpack_public_path__ + "media/domenj/home-7172244f.png";